import { ConfigProps } from '@config/types'

const config = ({ weatherUrl }: ConfigProps) => ({
  domain: `${weatherUrl}`,
  baseUrl: `${weatherUrl}/weather/v1/`,
  fetchExpirationTime: 30,
  meteoNewsUrl: 'https://meteonews.ch/de/Redirect/blick/',
})

export type configType = ReturnType<typeof config>
export default config
